import { get, noop } from 'lodash'
import React from 'react'

import { ColumnInfinityProps, TCellData, TRowData } from '../../types'
import CheckboxColumn from '../CheckboxColumn'

interface CellRenderedProps
  extends Pick<
    ColumnInfinityProps,
    | 'selectedItems'
    | 'toggleItem'
    | 'getIsSelectable'
    | 'selectionKey'
    | 'limitReached'
    | 'selectionLimit'
  > {
  isCheckColumn: boolean
  rowData?: TRowData
  cellData?: TCellData
}

const CellRendered = (props: CellRenderedProps): React.ReactElement | null => {
  const {
    isCheckColumn,
    selectionKey,
    getIsSelectable,
    selectedItems,
    limitReached,
    toggleItem = noop,
    selectionLimit,
  } = props

  if (isCheckColumn) {
    const key = get(props, ['rowData', selectionKey as string])
    let isSelectable = true
    if (getIsSelectable) {
      isSelectable = getIsSelectable(get(props, 'rowData'))
    }
    if (!isSelectable) {
      return null
    }
    const isSelected = get(selectedItems, key)
    const isDisabled = !isSelected && limitReached

    return (
      <CheckboxColumn
        value={isSelected as boolean}
        onChange={() => {
          toggleItem(key)
        }}
        disabled={isDisabled}
        tooltip={
          isDisabled
            ? i18n.t('table_selection_limit_reached', {
                defaultValue:
                  'Es können maximal {{limit}} Elemente ausgewählt werden',
                limit: selectionLimit,
              })
            : null
        }
      />
    )
  }
  return (
    <div {...props}>
      <span>{get(props, 'cellData')}</span>
    </div>
  )
}

export default CellRendered
